export default __webpack_public_path__ + "static/media/cancel.63c2da80.svg";